<template>
  <div>
    <hospitals-search-tools />
    <hospitals-search-table/>
    <hospitals-edit-popup />
  </div>
</template>

<script>
import HospitalsSearchTools from '@/components/Hospitals/HospitalsSearchTools';
import HospitalsSearchTable from '@/components/Hospitals/HospitalsSearchTable';
import HospitalsEditPopup from '@/components/Hospitals/HospitalsEditPopup';

export default {
  name: 'HospitalsList',
  components: {
    HospitalsSearchTools,
    HospitalsSearchTable,
    HospitalsEditPopup,
  },
};
</script>
